import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function AiVisMark() {
  return (
    <svg className="home-option-logo" viewBox="0 0 112 112" aria-hidden>
      <rect width="112" height="112" fill="#a4c536" />
      <g fill="#4d515a">
        <rect x="18" y="58" width="20" height="32" rx="6" />
        <rect x="46" y="40" width="20" height="50" rx="6" />
        <rect x="74" y="20" width="20" height="70" rx="6" />
      </g>
    </svg>
  );
}

const capabilities = [
  { label: 'Measure', text: 'See how often AI answers name your brand.' },
  { label: 'Monitor', text: 'Track the prompts and sources behind those answers.' },
  { label: 'Engage', text: 'Run the Reddit work that supports the brand.' },
];

function Home() {
  return (
    <div className="home">
      <section className="home-story" aria-label="180 Marketing">
        <div className="home-story-top">
          <Link to="/" aria-label="180 Marketing home">
            <img className="home-logo" src="/Site-logo-180.png" alt="180" />
          </Link>
          <Link className="home-status" to="/status">Status</Link>
        </div>

        <div className="home-story-body">
          <p className="home-eyebrow">Applications portal</p>
          <h1>The tools behind 180 Marketing</h1>
          <p className="home-lede">
            One place to open the applications that measure AI visibility and run Reddit marketing.
          </p>
          <ul className="home-points">
            {capabilities.map((item) => (
              <li key={item.label}>
                <strong>{item.label}</strong>
                <span>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="home-story-foot">
          <p>180 Marketing &copy; {new Date().getFullYear()}</p>
          <div className="home-story-links">
            <a href="https://180marketing.com" rel="noopener noreferrer">Main Site</a>
          </div>
        </div>
      </section>

      <main className="home-choice">
        <div className="home-choice-panel">
          <div className="home-choice-intro">
            <p className="home-eyebrow">Choose an application</p>
            <h2>Open the product you came to use</h2>
          </div>

          <div className="home-options">
            <Link className="home-option home-option-aivis" to="/ai-vis/login">
              <AiVisMark />
              <span className="home-option-copy">
                <span className="home-option-kicker">Platform</span>
                <span className="home-option-title">AI-Vis</span>
                <span className="home-option-text">
                  Track prompts, visibility scores, and the domains AI cites when it answers.
                </span>
              </span>
              <span className="home-option-go">
                Open AI-Vis
                <span aria-hidden>→</span>
              </span>
            </Link>

            <Link className="home-option home-option-reddit" to="/reddit/login">
              <img className="home-option-logo" src="/reddit-portal-mark.jpg" alt="" />
              <span className="home-option-copy">
                <span className="home-option-kicker">Dashboard</span>
                <span className="home-option-title">Reddit Marketing</span>
                <span className="home-option-text">
                  Find the conversations that matter and manage the Reddit work around your brand.
                </span>
              </span>
              <span className="home-option-go">
                Open Reddit
                <span aria-hidden>→</span>
              </span>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Home;
